import { memo, useCallback } from "react";
import ModalWrapper from "..";
import { useTranslation } from "react-i18next";
import { Button } from "../../button";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  EVACUATION_EVENT_PARTICIPANTS_STATUSES,
  EVACUATION_METHODS,
} from "../../../constants/common";
import { useUpdateEvacuationEventParticipantStatus } from "../../../hooks/emergency-evacuation/mutation";

interface SafeEvacuationEventParticipantModalProps {
  musterPointId: number;
  selectedEventId: number | null;
  isOpen: boolean;
  onOpenChange: () => void;
}

const SafeEvacuationEventParticipantModal = ({
  musterPointId,
  selectedEventId,
  isOpen,
  onOpenChange,
}: SafeEvacuationEventParticipantModalProps) => {
  const { t } = useTranslation();

  const { handleSubmit } = useForm();

  const {
    mutateAsync: UpdateEvacuationEventParticipantStatus,
    isPending: isUpdateEvacuationEventParticipantStatusLoading,
  } = useUpdateEvacuationEventParticipantStatus();

  const onSafe = useCallback(async () => {
    if (!selectedEventId) return;

    try {
      const body = {
        n_EvacuationEventID: selectedEventId,
        n_EvacuationMethod: EVACUATION_METHODS.MANUAL,
        n_EvacuationStatus: EVACUATION_EVENT_PARTICIPANTS_STATUSES.SAFE,
        n_MusterPointID: musterPointId,
      };

      await UpdateEvacuationEventParticipantStatus(body);

      toast.success(t("participantMarkedSafe"));
    } catch (error) {
      toast.error(t("somethingWentWrong"));
    } finally {
      onOpenChange();
    }
  }, [UpdateEvacuationEventParticipantStatus, musterPointId, onOpenChange, selectedEventId, t]);

  return (
    <ModalWrapper isOpen={isOpen} onOpenChange={onOpenChange}>
      <form
        onSubmit={handleSubmit(onSafe)}
        className=" flex flex-col items-center justify-center gap-5 w-full"
      >
        <p className="text-lg font-medium">{t("confirmParticipantSafe")}</p>

        <div className="flex gap-2 items-center">
          <Button
            isLoading={isUpdateEvacuationEventParticipantStatusLoading}
            className="max-w-max bg-green-600 hover:bg-green-700"
          >
            {t("markSafe")}
          </Button>
          <Button
            onClick={onOpenChange}
            className="bg-transparent ring-1 ring-purple-primary text-purple-primary hover:bg-transparent"
          >
            {t("close")}
          </Button>
        </div>
      </form>
    </ModalWrapper>
  );
};

export default memo(SafeEvacuationEventParticipantModal);
